import {Badge, Divider, Space, Switch} from "antd";
import React, {useEffect, useState} from "react";
import {CheckOutlined} from "@ant-design/icons";
import RenderIf from "@/components/render-if";
import isLocal from "@/lib/helper/isLocal";

export const PermCard = ({
                             role, color, item,

                             allMyPermissions,
                             newPermission,
                             handleChange,
                             canEdit,
                             setNewPermission
                         }) => {

    const [checkAll, setCheckAll] = useState(false)
    const [onClickCheckAll, setOnClickCheckAll] = useState(false)

    useEffect(() => {

        if (onClickCheckAll) {
            let myNewPerms = []

            item?.data.forEach((row) => {
                myNewPerms.push(row?.name)
            })

            if (checkAll) {
                setNewPermission([...newPermission, ...myNewPerms])
            } else {
                let allOtherPermissions = []
                newPermission.map((row) => {
                    if (!myNewPerms.includes(row)) {
                        allOtherPermissions.push(row)
                    }
                })

                setNewPermission(allOtherPermissions)
            }

            setOnClickCheckAll(false)
        }


    }, [checkAll, onClickCheckAll])

    useEffect(() => {
        let countPerms = 0;
        item?.data.forEach((row) => {
            if (newPermission.includes(row.name)) {
                countPerms += 1
            }
        })

        if (countPerms === item.data.length) {
            setCheckAll(true)
        } else {
            setCheckAll(false)
        }
    }, [item?.data, newPermission])


    return (
        <div className="my-2">
            <div className=" border-gray-4 rounded-lg shadow-sm flex flex-col hover:shadow transition-all">
                <Space
                    direction="vertical"
                    size="middle"
                    style={{
                        width: '100%',
                    }}
                >
                    <Badge.Ribbon text={role} color={color} placement="start">
                        <div className=" flex justify-center">
                            <div className="pt-10 p-2 w-full">

                                <label className={'mx-2 cursor-pointer'}>
                                    انتخاب همه
                                    {' '}
                                    <Switch
                                        disabled={!canEdit}
                                        checked={checkAll}
                                        onChange={() => {
                                            setCheckAll(!checkAll);
                                            setOnClickCheckAll(true)
                                        }}
                                        checkedChildren={<CheckOutlined/>}
                                        unCheckedChildren={<span className={'icon icon-lock-keyhole'}></span>}>
                                    </Switch>
                                </label>
                                <Divider type={"horizontal"} size={'small'}/>
                                <div
                                    className="flex-wrap md:flex gap-2">
                                    {item.data.map((perm, i) => {
                                        return (
                                            <div key={'perm' + perm.name + '-' + i}>
                                                <label className="flex gap-2 cursor-pointer select-none my-2">
                                                    <div className={'flex flex-col mr-4'} title={perm?.key}>
                                                        <span className="">{perm?.description}</span>
                                                        <RenderIf condition={isLocal()}>
                                                            <code className={`text-xs text-gray-500`}
                                                                  style={{fontSize: "9px"}}>{perm?.key}</code>
                                                        </RenderIf>
                                                    </div>
                                                    <div>
                                                        <Switch disabled={!canEdit}
                                                                defaultChecked={allMyPermissions.includes(perm?.name)}
                                                                checked={newPermission.includes(perm?.name)}
                                                                onChange={() => handleChange(perm?.name)}
                                                                checkedChildren={<CheckOutlined/>}
                                                                unCheckedChildren={<span
                                                                    className={'icon icon-lock-keyhole'}></span>}></Switch>
                                                        <Divider type={"vertical"}/>
                                                    </div>
                                                </label>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </Badge.Ribbon>
                </Space>
            </div>
        </div>
    )
}
export const TextPerm = ({text}) => {
    return (
        <span>{text}</span>
    )
}

